import { Component, ElementRef, Renderer2, ViewChild } from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { DataShareService } from "src/app/core/services/datashare.sevice";
import { StorageService } from "src/app/core/services/storage.service";
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { environment } from "src/environments/environment";
import { ToastService } from "src/app/core/services/toast.service";
import { filter } from "rxjs/operators";

@Component({
  selector: 'BTA-home-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss']
})

export class HomeHeaderComponent {
  public logoUrl = environment?.logoUrl;
  public imageUrl = environment?.imageUrl;
  public logoHeight = environment?.logoHeight;
  public logoFailed = false;
  clientAbbr = environment.clientAbbr;
  @ViewChild('dropDown') dropDown!: ElementRef;
  countries = [];
  isDropdownOpen = false;
  selectedCountry = {
    "name": '',
    "country_code": '',
    "currency_symbol": '',
    "id": '',
    // "customerNo": '',
    "calling_code": '',
    "flag": ""
  }
  public profileIcon: boolean = false;
  showLanguageDropdown = false;

  // imageUrl + logoUrl is the CDN copy; when it 404s (or the CDN is down) fall
  // back to logoUrl on its own. Guarded so a failing fallback can't re-enter.
  onLogoError() {
    if (!this.logoFailed) this.logoFailed = true;
  }

  constructor(private renderer: Renderer2, private storageService: StorageService, private commonService: CommonService, private sharedService: DataShareService, private toastrService: ToastService, private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showLanguageDropdown = event.url.includes('tutorial');
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const urlSegments = event.urlAfterRedirects.split('/');
        const langCode = urlSegments[urlSegments.length - 1];

        // Find matching language from the list
        const matchedLang = this.languageList.find(
          lang => lang.code.toLowerCase() === langCode.toLowerCase()
        );

        if (matchedLang) {
          this.selectedLanguage = matchedLang;
        }
      });
  }

  ngOnInit() {
    this.sharedService.counrtyCodeSubject$.subscribe((response: []) => {
      response.forEach((element: any) => {
        const myJson = {
          "name": element.country_name,
          "country_code": element.country_code,
          "currency_symbol": element.currency_symbol,
          "id": element.id,
          "customerNo": element.customercare_no_Flight,
          "calling_code": element.calling_code,
          "flag": this.imageUrl + "assets/images/flags/" + element.country_code + '.svg'
        }
        this.countries.push(myJson);
      });
      this.backfillCallingCode();
    })
    this.getInitailSetUp();
  }

  languageList = [
    { code: 'english', label: 'ENGLISH' },
    { code: 'hindi', label: 'HINDI' },
    { code: 'bengali', label: 'BENGALI' }
  ];

  selectedLanguage = this.languageList[0]; // Default to English

  changeLanguage(lang: any) {
    this.selectedLanguage = lang;

    // Get current path segments
    const segments = this.router.url.split('/');

    // Replace the last segment (language code) with the new one
    if (segments.length > 0) {
      segments[segments.length - 1] = lang.code;
      const newUrl = segments.join('/');

      // Navigate to the new URL
      this.router.navigateByUrl(newUrl);
    }
  }

  getInitailSetUp() {
    this.commonService.getInit().subscribe((response: Response) => {
      let selectedCountry = JSON.parse(JSON.stringify(response))
      this.selectedCountry = {
        "name": selectedCountry.country_name,
        "country_code": selectedCountry.country_code,
        "currency_symbol": selectedCountry.currency_symbol,
        "id": selectedCountry.country_id,
        // Login posts selected_country.calling_code as its country_code. The
        // user-ip response does not carry a dial code, so resolve it from the
        // shared country list; selectCountry() below already stores one.
        "calling_code": selectedCountry.calling_code || this.callingCodeFor(selectedCountry.country_code),
        "flag": this.imageUrl + "assets/images/flags/" + selectedCountry.country_code + '.svg'
      }
      this.storageService.setLocalStorageItem('selected_country', this.selectedCountry)
    })
  }

  // The country list and the user-ip call race each other, so the dial code may
  // not be resolvable yet when getInitailSetUp() stores the country.
  private callingCodeFor(countryCode: string): string {
    return this.countries?.find(
      (c: any) => c.country_code?.toLowerCase() === countryCode?.toLowerCase()
    )?.calling_code || '';
  }

  // Runs once the country list lands: if the stored country was written before
  // the list was available it has no dial code, which makes login send an empty
  // country_code. Fill it in rather than waiting for the user to pick a country.
  private backfillCallingCode() {
    const stored = this.storageService.getLocalStorageItem('selected_country');
    if (!stored || stored.calling_code) return;
    const calling_code = this.callingCodeFor(stored.country_code);
    if (!calling_code) return;
    this.storageService.setLocalStorageItem('selected_country', { ...stored, calling_code });
    this.selectedCountry.calling_code = calling_code;
  }

  toggleCountryDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.renderer.removeStyle(this.dropDown.nativeElement, 'display',)
    } else {
      this.renderer.setStyle(this.dropDown.nativeElement, 'display', 'none')
    }
  }
  selectCountry(country: any) {
    this.storageService.setLocalStorageItem('selected_country', country)
    this.selectedCountry = country;
  }
}